import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { SFTrendIcon } from "../../../icons/trend";
import SFTypography from "../../../typography";

const SFTrendRenderer = (props) => {
  const { t } = useTranslation();
  return (
    <React.Fragment>
      {props.value ? (
        <SFTrendIcon variant="secondary" trend={props.value} size={props.size} />
      ) : (
        <SFTypography variant="tableList">
          {t("components.datagrid.filters.blankValue")}
        </SFTypography>
      )}
    </React.Fragment>
  );
};

SFTrendRenderer.propTypes = {
  value: PropTypes.string,
};

export default SFTrendRenderer;
